import { PropsWithChildren } from "react";
import { Grid, SxProps } from "@mui/material";
import { OptionalClassName } from "../../utils/types";

export type ResponsiveGridNumbers = {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
};

export const GridContainer = ({
  children,
  spacing = 2,
  columnSpacing,
  rowSpacing,
  sx,
  className,
}: OptionalClassName<
  PropsWithChildren<{
    spacing?: number | ResponsiveGridNumbers;
    columnSpacing?: number | ResponsiveGridNumbers;
    rowSpacing?: number | ResponsiveGridNumbers;
    sx?: SxProps;
  }>
>) => {
  return (
    <Grid
      container
      spacing={spacing}
      columnSpacing={columnSpacing}
      rowSpacing={rowSpacing}
      columns={12}
      sx={sx}
      className={className}
    >
      {children}
    </Grid>
  );
};
